module.exports = __webpack_public_path__ + "img/intro_no.a35ff934.svg";